import { atom } from "recoil"

export const myListTeamRequestIdState = atom({
  key: "atoms/team/myListTeamRequestIdState",
  default: 0,
})
